/* Tha Layover — PDP pre-order state. Runs after tl-product-page's own variant change handler. */
(function () {
  'use strict';
  function init(page) {
    if (page.dataset.poBound) return;
    var select = page.querySelector('[data-variant-select]');
    var btn = page.querySelector('[data-add-to-cart]');
    if (!select || !btn) return;
    page.dataset.poBound = '1';
    var variants = [];
    try { variants = JSON.parse(page.querySelector('[data-variants]').textContent || '[]'); } catch (e) {}
    var text = page.querySelector('[data-add-text]');
    var input = page.querySelector('[data-po-input]');
    var note = page.querySelector('[data-po-note]');
    var status = page.querySelector('[data-variant-status]');

    function apply() {
      var v = variants.find(function (x) { return String(x.id) === String(select.value); });
      var po = !!(v && v.available && v.preorder);
      if (input) input.disabled = !po;
      if (note) note.hidden = !po;
      btn.classList.toggle('is-preorder', po);
      if (po && page.dataset.requiresPlan !== 'true') {
        if (text) text.textContent = page.dataset.poLabel;
        if (status) status.textContent = page.dataset.poLabel;
      }
    }
    page.addEventListener('change', apply);
    apply();
  }
  document.querySelectorAll('tl-product-page').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('tl-product-page').forEach(init); });
})();
